import Main from '@/components/main'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: 'loadding',
    meta: {
      title: '',
      hideInMenu: true
    },
    component: () => import('@/view/loadding/index.vue')
  },
  {
    path: '/home',
    name: '_home',
    redirect: '/home',
    component: Main,
    meta: {
      notCache: true
    },
    children: [

      {
        path: '/home',
        name: 'home',
        meta: {
          title: '首页',
          notCache: true
          // icon: 'md-home',
        },
        component: () => import('@/view/home/home')
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/home-display',
    name: 'home-display',
    redirect: '/home-display',
    component: Main,
    meta: {
      title: '首页展示'
    },
    children: [
      {
        path: '/home-display',
        name: 'home-display',
        meta: {
          title: '首页展示'
          // icon: 'md-home',
        },
        component: () => import('@/view/home-display/index')
      }

    ]
  },
  {
    path: '/order-records',
    name: 'order-records',
    redirect: '/order-records',
    component: Main,
    meta: {
      title: '订单管理'
    },
    children: [
      {
        path: '/order-records',
        name: 'order-records',
        meta: {
          title: '订单管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/order-records/index')
      }

    ]
  },
  {
    path: '/after-sales-manage',
    name: 'after-sales-manage',
    redirect: '/after-sales-manage',
    component: Main,
    meta: {
      title: '售后管理'
    },
    children: [
      {
        path: '/after-sales-manage',
        name: 'after-sales-manage',
        meta: {
          title: '售后管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/after-sales-manage/index')
      }
    ]
  },
  {
    path: '/referrerReport',
    name: 'referrerReport',
    redirect: '/referrerReport',
    component: Main,
    meta: {
      title: '地推业绩'
    },
    children: [
      {
        path: '/referrerReport',
        name: 'referrerReport',
        meta: {
          title: '地推业绩'
          // icon: 'md-home',
        },
        component: () => import('@/view/referrerReport/List')
      }
    ]
  },
  {
    path: '/product-manage',
    name: 'product-manage',
    redirect: '/product-manage',
    component: Main,
    meta: {
      title: '产品管理'
    },
    children: [
      {
        path: '/product-manage',
        name: 'product-manage',
        meta: {
          title: '产品管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/product-manage/index')
      },
      {
        path: '/add-product',
        name: 'add-product',
        meta: {
          title: '产品管理',
          hideInMenu: true
          // icon: 'md-home',
        },
        component: () => import('@/view/product-manage/add-product')
      }
    ]
  },
  {
    path: '/product-price',
    name: 'product-price',
    redirect: '/product-price',
    component: Main,
    meta: {
      title: '产品价格'
    },
    children: [
      {
        path: '/product-price',
        name: 'product-price',
        meta: {
          title: '产品价格'
        },
        component: () => import('@/view/product-price/product-price')
      },
      {
        path: '/show-price',
        name: 'show-price',
        meta: {
          title: '产品报价',
          hideInMenu: true
          // icon: 'md-home',
        },
        component: () => import('@/view/product-price/show-price')
      }
    ]
  },
  {
    path: '/industrial-manage',
    name: 'industrial-manage',
    redirect: '/industrial-manage',
    component: Main,
    meta: {
      title: '行业管理'
    },
    children: [
      {
        path: '/industrial-manage',
        name: 'industrial-manage',
        meta: {
          title: '行业管理'
        },
        component: () => import('@/view/industrial-manage/index')
      }
    ]
  },
  {
    path: '/classification-manage',
    name: 'classification-manage',
    redirect: '/classification-manage',
    component: Main,
    meta: {
      title: '分类管理'
    },
    children: [
      {
        path: '/classification-manage',
        name: 'classification-manage',
        meta: {
          title: '分类管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/classification-manage/index')
      }
    ]
  },
  {
    path: '/template-manage',
    name: 'template-manage',
    redirect: '/template-manage',
    component: Main,
    meta: {
      title: '模板管理'
    },
    children: [
      {
        path: '/template-manage',
        name: 'template-manage',
        meta: {
          title: '模板管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/template-manage/index')
      }
    ]
  },
  {
    path: '/advertisement-manage',
    name: 'advertisement-manage',
    redirect: '/advertisement-manage',
    component: Main,
    meta: {
      title: '广告管理',
    },
    children: [
      {
        path: '/advertisement-manage',
        name: 'advertisement-manage',
        meta: {
          title: '广告管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/advertisement-manage/index')
      },
      {
        path: '/advertisement-edit',
        name: 'advertisement-edit',
        meta: {
          title: '发布广告',
          hideInMenu:true,
          // icon: 'md-home',
        },
        component: () => import('@/view/advertisement-manage/advertisement-edit')
      }
    ]
  },
  {
    path: '/user-manage',
    name: 'user-manage',
    redirect: '/user-manage',
    component: Main,
    meta: {
      title: '用户管理'
    },
    children: [
      {
        path: '/user-manage',
        name: 'user-manage',
        meta: {
          title: '用户管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/user-manage/index')
      },
      {
        path: '/points-details',
        name: 'points-details',
        meta: {
          title: '积分明细',
          hideInMenu: true
          // icon: 'md-home',
        },
        component: () => import('@/view/user-manage/points-details')
      },
      {
        path: '/user-promote',
        name: 'user-promote',
        meta: {
          title: '推广明细',
          hideInMenu: true
          // icon: 'md-home',
        },
        component: () => import('@/view/user-manage/user-promote')
      }
    ]
  },
  {
    path: '/freight-manage',
    name: 'freight-manage',
    redirect: '/freight-manage',
    component: Main,
    meta: {
      title: '运费管理'
    },
    children: [
      {
        path: '/freight-manage',
        name: 'freight-manage',
        meta: {
          title: '运费管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/freight-manage/index')
      }
    ]
  },
  {
    path: '/coupon-package',
    name: 'coupon-package',
    redirect: '/coupon-package',
    component: Main,
    meta: {
      title: '优惠券包'
    },
    children: [
      {
        path: '/coupon-package',
        name: 'coupon-package',
        meta: {
          title: '优惠券包'
          // icon: 'md-home',
        },
        component: () => import('@/view/coupon-package/index')
      },
      {
        path: '/add-coupon',
        name: 'add-coupon',
        meta: {
          title: '编辑优惠券',
          hideInMenu: true
          // icon: 'md-home',
        },
        component: () => import('@/view/coupon-package/add-coupon')
      }
    ]
  },
  {
    path: '/invoice-manage',
    name: 'invoice-manage',
    redirect: '/invoice-manage',
    component: Main,
    meta: {
      title: '开票管理'
    },
    children: [
      {
        path: '/invoice-manage',
        name: 'invoice-manage',
        meta: {
          title: '开票管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/invoice-manage/index')
      }
    ]
  },
  {
    path: '/withdrawal-manage',
    name: 'withdrawal-manage',
    redirect: '/withdrawal-manage',
    component: Main,
    meta: {
      title: '提现管理'
    },
    children: [
      {
        path: '/withdrawal-manage',
        name: 'withdrawal-manage',
        meta: {
          title: '提现管理'
          // icon: 'md-home',
        },
        component: () => import('@/view/withdrawal-manage/index')
      }
    ]
  },
  {
    path: '/cashout-statistics',
    name: 'cashout-statistics',
    redirect: '/cashout-statistics',
    component: Main,
    meta: {
      title: '提现管理'
    },
    children: [
      {
        path: '/cashout-statistics',
        name: 'cashout-statistics',
        meta: {
          title: '提现统计'
          // icon: 'md-home',
        },
        component: () => import('@/view/withdrawal-manage/statistics')
      }
    ]
  },
  {
    path: '/payment-details',
    name: 'payment-details',
    redirect: '/payment-details',
    component: Main,
    meta: {
      title: '支付明细'
    },
    children: [
      {
        path: '/payment-details',
        name: 'payment-details',
        meta: {
          title: '支付明细'
          // icon: 'md-home',
        },
        component: () => import('@/view/payment-details/index')
      }
    ]
  },
  {
    path: '/transaction-details',
    name: 'transaction-details',
    redirect: '/transaction-details',
    component: Main,
    meta: {
      title: '交易明细'
    },
    children: [
      {
        path: '/transaction-details',
        name: 'transaction-details',
        meta: {
          title: '交易明细'
          // icon: 'md-home',
        },
        component: () => import('@/view/transaction-details/index')
      }
    ]
  },
  {
    path: '/factory-order',
    name: 'factory-order',
    redirect: '/factory-order',
    component: Main,
    meta: {
      title: '工厂订单'
    },
    children: [
      {
        path: '/factory-order',
        name: 'factory-order',
        meta: {
          title: '工厂订单'
        },
        component: () => import('@/view/factory-order/index')
      }
    ]
  },
  {
    path: '/ad-factory',
    name: 'ad-factory',
    redirect: '/ad-factory',
    component: Main,
    meta: {
      title: '工厂管理'
    },
    children: [
      {
        path: '/ad-factory',
        name: 'ad-factory',
        meta: {
          title: '工厂管理'
        },
        component: () => import('@/view/ad-factory/index')
      }
    ]
  },
  {
    path: '/cust-referrer',
    name: 'cust-referrer',
    redirect: '/cust-referrer',
    component: Main,
    meta: {
      title: '推广客户'
    },
    children: [
      {
        path: '/cust-referrer',
        name: 'cust-referrer',
        meta: {
          title: '推广客户'
        },
        component: () => import('@/view/cust-referrer/cust-referrer')
      }
    ]
  },
  {
    path: '/unique-visitor',
    name: 'unique-visitor',
    redirect: '/unique-visitor',
    component: Main,
    meta: {
      title: '独立访客'
    },
    children: [
      {
        path: '/unique-visitor',
        name: 'unique-visitor',
        meta: {
          title: '独立访客'
        },
        component: () => import('@/view/unique-visitor/index')
      }
    ]
  },
  {
    path: '/userlog',
    name: 'userlog',
    redirect: '/userlog',
    component: Main,
    meta: {
      title: '日报'
    },
    children: [
      {
        path: '/userlog',
        name: 'userlog',
        meta: {
          title: '日报'
        },
        component: () => import('@/view/userlog/userlog')
      }
    ]
  },
  {
    path: '/bill-detail',
    name: '/bill-detail',
    redirect: '/bill-detail',
    component: Main,
    meta: {
      title: '收支明细'
    },
    children: [
      {
        path: '/bill-detail',
        name: '/bill-detail',
        meta: {
          title: '收支明细'
        },
        component: () => import('@/view/bill-detail/index')
      }
    ]
  },
  {
    path: '/system',
    name: 'system',
    meta: {
      title: '系统管理',
      icon: 'logo-windows'
    },
    component: Main,
    children: [
      {
        path: 'account-manage',
        name: 'account-manage',
        meta: {
          title: '账号管理'
        },
        component: () => import('@/view/system/account-manage/account-manage')
      },
      {
        path: 'add-account',
        name: 'add-account',
        meta: {
          hideInMenu: true,
          title: '添加账号'
        },
        component: () => import('@/view/system/account-manage/add-account')
      },
      {
        path: 'role-permissions',
        name: 'role-permissions',
        meta: {
          title: '角色权限'
        },
        component: () => import('@/view/system/role-permissions/role-permissions')
      },
      {
        path: 'auth',
        name: 'auth',
        meta: {
          title: '菜单管理'
        },
        component: () => import('@/view/system/auth/auth-manage')
      },

      {
        path: 'system-config',
        name: 'system-config',
        meta: {
          title: '系统配置'

        },
        component: () => import('@/view/system/system-config/system-config')
      },
      {
        path: 'dict-type',
        name: 'dict-type',
        meta: {
          title: '字典管理'
        },
        component: () => import('@/view/system/dict/dict-type')
      },
      {
        path: 'dict-data',
        name: 'dict-data',
        meta: {
          title: '字典数据',
          hideInMenu: true
        },
        component: () => import('@/view/system/dict/dict-data')
      },
      {
        path: 'dict-demo',
        name: 'dict-demo',
        meta: {
          title: '字典标签演示',
          hideInMenu: true
        },
        component: () => import('@/view/system/dict/dict-demo')
      }
    ]
  },
  {
    path: '/franchise-store',
    name: 'franchise-store',
    component: Main,
    meta: {
      title: '加盟门店'
    },
    children: [
      {
        path: '/franchise-store',
        name: 'franchise-store',
        meta: {
          title: '加盟门店'
        },
        component: () => import('@/view/franchise-store/index')
      }
    ]
  },
  {
    path: '/consumable',
    name: 'consumable',
    component: Main,
    meta: {
      title: '耗材管理'
    },
    children: [
      {
        path: '/consumable',
        name: 'consumable',
        meta: {
          title: '耗材管理'
        },
        component: () => import('@/view/consumable/index')
      }
    ]
  },
  {
    path: '/installer',
    name: 'installer',
    component: Main,
    meta: {
      title: '安装工管理'
    },
    children: [
      {
        path: '/installer',
        name: 'installer',
        meta: {
          title: '安装工管理'
        },
        component: () => import('@/view/installer/index')
      }
    ]
  },

  {
    path: '/403',
    name: 'error_403',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/403.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
